/**
 * TypeScript Demo Component
 * Adds interactivity to the hero code window
 */

export class TSDemo {
  private element: HTMLElement | null;
  private codeLines: string[] = [
    '<span class="token--keyword">const</span> status = <span class="token--string">"coding"</span>;',
    '<span class="token--keyword">type</span> Goal = <span class="token--string">"Innovation"</span> | <span class="token--string">"Efficiency"</span>;',
    '<span class="token--keyword">let</span> current: Goal = <span class="token--string">"Innovation"</span>;'
  ];

  constructor(selector: string) {
    this.element = document.querySelector(selector);
  }

  public init(): void {
    if (!this.element) return;

    // Add a hover effect that "compiles" the code
    this.element.addEventListener('mouseenter', () => {
      this.element?.classList.add('compiling');
      this.showMagic();
    });

    this.element.addEventListener('mouseleave', () => {
      this.element?.classList.remove('compiling');
    });
  }

  private showMagic(): void {
    if (!this.element) return;
    const codeContainer = this.element.querySelector('code');
    if (!codeContainer) return;

    // Typewriter effect enhancement
    let currentLine = 0;
    const originalContent = codeContainer.innerHTML;
    codeContainer.innerHTML = '';

    const typeLine = () => {
      if (currentLine < this.codeLines.length) {
        codeContainer.innerHTML += this.codeLines[currentLine] + '\n';
        currentLine++;
        setTimeout(typeLine, 200);
      }
    };
    
    typeLine();

    // Reset after some time
    setTimeout(() => {
      if (this.element?.classList.contains('compiling')) return;
      codeContainer.innerHTML = originalContent;
    }, 5000);
  }
}
